// extracted by mini-css-extract-plugin
export default {"bgSite":"Cadastro_bgSite__Wzjkk"};